<template>
  <transition name="fade" mode="out-in">
    <router-view/>
  </transition>
</template>
<script>
import '@/css/style.scss'
import '@fortawesome/fontawesome-free/css/all.css'
import 'animate.css/animate.css'

export default {
  metaInfo () {
    return {
      title: this.$_.upperFirst(this.$tc(this.$route.meta.title))
    }
  },
  created () {
    this.checkAuth()
  },
  mounted () {
    // console.log(window.innerHeight)
    const root = document.documentElement
    root.style.setProperty('--vh', window.innerHeight + 'px')
    window.addEventListener('resize', this.resize)
    window.addEventListener('scroll', this.scroll)
  },
  destroyed () {
    window.removeEventListener('resize', this.resize)
    window.removeEventListener('scroll', this.scroll)
  },
  methods: {
    async checkAuth () {
      await this.$store.dispatch('user/checkAuth')
      await this.$store.dispatch('user/getMe')
        .catch(() => {
          console.log('польователь не авторизован')
        })
    },
    resize () {
      // set globale event when event window.resize
      this.$root.$emit('resize', true)
      const root = document.documentElement
      root.style.setProperty('--vh', window.innerHeight + 'px')
    },
    scroll () {
      // set globale event when event window.scroll
      this.$root.$emit('scroll', true)
    }
  }
}
</script>
<style lang="scss">
  /* fade amination */
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
  }
  /* fade amination end */

  label, .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Opera and Firefox */
  }
</style>
